import { gql } from "@apollo/client";

export const LOGIN_MUTATION = gql`
  mutation Login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      token
      role
      email
      message
    }
  }
`;

export const VERIFY_OTP_MUTATION = gql`
  mutation VerifyOtp($email: String!, $otp: String!) {
    verifyOtp(email: $email, otp: $otp) {
      token
      role
      email
      message
    }
  }
`;

export const FORGOT_PASSWORD_MUTATION = gql`
  mutation ForgetPassword($email: String!) {
    forgetPassword(email: $email) {
      token
      role
      email
      message
    }
  }
`;

export const VERIFY_RESET_OTP_MUTATION = gql`
  mutation VerifyResetOtp($email: String!, $otp: String!) {
    verifyResetOtp(email: $email, otp: $otp) {
      token
      role
      email
      message
    }
  }
`;

export const RESET_PASSWORD = gql`
  mutation resetPassword(
    $email: String!
    $otp: String!
    $newPassword: String!
  ) {
    resetPassword(email: $email, otp: $otp, newPassword: $newPassword) {
      token
      role
      email
      message
    }
  }
`;

export const ME_QUERY = gql`
  query Me {
    me {
      id
      email
      role
    }
  }
`;

export const LOGOUT_MUTATION = `
  mutation Logout {
    logout {
      message
      success
    }
  }
`;

export const CREATE_USER_MUTATION = gql`
  mutation CreateUser($email: String!, $role: String!) {
    createUser(email: $email, role: $role) {
      email
      message
    }
  }
`;

export const GET_ALL_USERS_QUERY = gql`
  query GetAllUsers {
    getAllUsers {
      id
      email
      role
    }
  }
`;

export const GET_ALL_USERS_EXCEPT_ME_QUERY = gql`
  query GetAllUsersExceptMe {
    getAllUsersExceptMe {
      email
      role
    }
  }
`;

export const CHANGE_USER_ROLE_MUTATION = gql`
  mutation ChangeUserRole($targetUserEmail: String!, $newRole: String!) {
    changeUserRole(targetUserEmail: $targetUserEmail, newRole: $newRole)
  }
`;